import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ResultStage, StudentLoanCalculationParameters } from 'api/StudentLoanApi';
import { failureNotification } from 'notifications';
import { getStudentLoanData } from 'selectors/getStudentLoanData';
import { updateStudentLoanAssistanceData } from 'thunks';

import useDispatchWithUnwrap from './useDispatchWithUnwrap';

export const reportStudentLoanSaveFailure = () => {
  failureNotification("We couldn't save your answers. Please try again.");
};

/** Saves the answers from one question screen and returns the stage the calculator reached with them. */
const useSaveStudentLoanAnswers = () => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const { applicationId } = useSelector(getStudentLoanData);
  const [isSaving, setIsSaving] = useState(false);

  const saveAnswers = async (answers: StudentLoanCalculationParameters): Promise<ResultStage> => {
    setIsSaving(true);
    try {
      const { result } = await dispatchWithUnwrap(
        updateStudentLoanAssistanceData({ applicationId: applicationId!, ...answers }),
      );
      return result.stage;
    } finally {
      setIsSaving(false);
    }
  };

  return { saveAnswers, isSaving };
};

export default useSaveStudentLoanAnswers;
